module.exports = __webpack_public_path__ + "static/media/campus_25.77c69f55.png";